import * as React from 'react';

function LoginIcon(props) {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width={16} height={16} viewBox='0 0 16 16' fill='none' {...props}>
			<path
				d='M10 2h2.667A1.333 1.333 0 0114 3.333v9.334A1.334 1.334 0 0112.667 14H10m-3.333-2.667L10 8m0 0L6.667 4.667M10 8H2'
				stroke='#545454'
				strokeWidth={1.33333}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
}

export default LoginIcon;
